import React from 'react';
import PropTypes from 'prop-types';
import LockIcon from 'Components/icons/LockIcon';
// Card # is hard-coded for testing until the API provides the proper info
const TimelineTransaction = (props) => {
  const { fill } = props;
  const {
    CardInfo, CurrencyCode, TransactionAmount, firstSix, lastFour, TransactionId,
  } = props.listItem.eventBodyDetails;
  const amount = parseFloat(TransactionAmount).toFixed(2);
  const transactionClass = CardInfo ? 'thirds' : 'half';
  return (
    <div className="content-header transaction">
      <div className={transactionClass}>
        <div className="transaction-label">Transaction ID</div>
        <h3 className="transaction-id">{TransactionId}</h3>
      </div>
      <div className={transactionClass}>
        <div className="transaction-label">Amount</div>
        <h3 className="transaction-amount">
          {amount}
          <span className="currency">{CurrencyCode}</span>
        </h3>
      </div>
      {CardInfo && (
        <div className={transactionClass}>
          <div className="transaction-label">Card Number</div>
          <h3 className="transaction-card-info">
            {CardInfo}
            <LockIcon fill={fill} />
          </h3>
        </div>
      )}
    </div>
  );
};

TimelineTransaction.propTypes = {
  listItem: PropTypes.object.isRequired,
  fill: PropTypes.string,
};

TimelineTransaction.defaultProps = {
  fill: 'grey',
};
export default TimelineTransaction;
